module.exports = __webpack_public_path__ + "img/mira-document-scanner.92170493.svg";